exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "st-icp .icp{padding:4px 0;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/icp/icp.scss
// module id = 133
// module chunks = 0